import { Datagrid, ListProps, SelectField, TextField } from 'react-admin';
import { CustomList, SortableDatagridBody } from '../../components';
import ActiveField from '../../components/ActiveField';

export default function ValorizationItemsList(props: ListProps) {
  return (
    <CustomList
      {...props}
      filter={{
        $limit: -1,
        $sort: 'position'
      }}
      pagination={false}
    >
      <Datagrid
        body={<SortableDatagridBody filterColumn="category" />}
        rowClick="edit"
      >
        <TextField label="Título" source="title" sortable={false} />

        <SelectField
          choices={[
            { id: 'POSTS', name: 'Novidades' },
            { id: 'PROGRAMS', name: 'Programas' }
          ]}
          label="Categoria"
          source="category"
          sortable={false} 
        />

        <ActiveField label="Ativo" />
      </Datagrid>
    </CustomList>
  );
}
